import api from './index'
import {
	axios,
	pureAxios,
	pyAxios
} from '@/utils/request'
import {
	downLoadXlxs,
	downLoadPdf,
	downLoadXlxs3
} from '@/utils/index'

export function tianqiapi(parameter) {
	return axios({
		url: 'https://tianqiapi.com/api',
		method: 'get',
		params: parameter
	})
}


// export function get_checkin(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_checkin_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }

// 资产移交的列表查询
export function getTransferList(parameter) {
	return axios({
		url: '/daily/transfer/list',
		method: 'get',
		params: parameter
	})
}
//固定资产查询列表
export function daily_list(parameter) {
	return axios({
		url: '/daily/asset/list',
		method: 'get',
		params: parameter
	})
}

//获取耗材盘点详情
export function consumables_get(parameter) {
  return axios({
    url: api.gateway_act+'consumables/biz/'+parameter,
    method: 'get',
  })
}

export function consumables_code(parameter) {
	return axios({
		url: api.gateway_act+'consumables/code',
		method: 'get',
		params: parameter
	})
}

// export function get_checkout(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_checkout_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }

// export function purchase(status) {
// 	return pyAxios({
// 		url: '/req/purchase/get_list?status=' + status,
// 		method: 'get'
// 	})
// }
//入库
// export function checkin(parameter) {
// 	return pyAxios({
// 		url: '/receipt/checkin2',
// 		method: 'post',
// 		data: parameter
// 	})
// }

export function consumables_save(parameter) {
	return axios({
		url: api.gateway_act+'consumables/save',
		method: 'post',
		data: parameter
	})
}

// export function assetget_list(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }

// export function assetget_list2(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_list2',
// 		method: 'get',
// 		params: parameter
// 	})
// }

export function dict(parameter) {
	return axios({
		url: api.gateway_system+'dict/data/list',
		method: 'get',
		params: parameter
	})
}

export function dept_get(parameter) {
	return axios({
		url: api.gateway_system+'dept/get/' + parameter,
		method: 'get',
	})
}

// export function batch_save_value(parameter) {
// 	return pyAxios({
// 		url: '/asset/batch_save_value',
// 		method: 'post',
// 		data: parameter
// 	})
// }

// export function update(parameter) {
// 	return pyAxios({
// 		url: '/asset/update',
// 		method: 'post',
// 		data: parameter
// 	})
// }

// export function skuget_list(parameter) {
// 	return pyAxios({
// 		url: '/sku/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function skuget(parameter) {
// 	return pyAxios({
// 		url: '/sku/get',
// 		method: 'get',
// 		params: parameter
// 	})
// }
export function configlist(parameter) {
	return axios({
		url: api.gateway_system+'config/list',
		method: 'get',
		params: parameter
	})
}
export function configupdate(parameter) {
	return axios({
		url: api.gateway_system+'config/update',
		method: 'post',
		data: parameter
	})
}
export function update_wx(parameter) {
	return axios({
		url: api.gateway_system+'user/update_wx',
		method: 'post',
		data: parameter
	})
}
export function businesslist(parameter) {
	return axios({
		url: api.gateway_act+'business/list/my',
		method: 'get',
		params: parameter
	})
}
//资产报废出库列表
export function scrappedList(parameter) {
	return axios({
		url: '/act/business/list/scrapped',
		method: 'get',
		params: parameter
	})
}
export function scrapped_apply(parameter) {
	return axios({
		url: api.gateway_act+'scrapped_apply/save',
		method: 'post',
		data: parameter
	})
}
// export function skucheckout(parameter) {
// 	return pyAxios({
// 		url: '/sku/batch_checkout',
// 		method: 'post',
// 		data: parameter
// 	})
// }
// export function sku_get_checkin_records(parameter) {
// 	return pyAxios({
// 		url: '/sku/get_checkin_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function sku_checkin(parameter) {
// 	return pyAxios({
// 		url: '/sku/get_checkin_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function asset_checkin(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_checkin_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function asset_checkout(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_checkout_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function sku_checkout(parameter) {
// 	return pyAxios({
// 		url: '/sku/get_checkout_records',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function sku_spu(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// export function spu_get_list(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }
export function upload(parameter) {
	return pyAxios({
		url: '/file/upload',
		method: 'post',
		data: parameter
	})
}
// export function get_dept_tree(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_dept_tree',
// 		method: 'get'
// 	})
// }
// export function get_dept_tree2(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_dept_tree2',
// 		method: 'get'
// 	})
// }
//删除文件
export function remove(parameter) {
	return pyAxios({
		url: '/file/remove',
		method: 'get',
		params: parameter
	})
}
// export function post_asset(parameter) {
// 	return pyAxios({
// 		url: '/receipt/entry',
// 		method: 'post',
// 		data: parameter
// 	})
// }
export function modify_pwd(parameter) {
	return axios({
		url: api.gateway_system+'user/modify_pwd',
		method: 'post',
		data: parameter
	})
}
export function user_update(parameter) {
	return axios({
		url: api.gateway_system+'user/update/avatar',
		method: 'post',
		data: parameter
	})
}
// export function fake_sku_list(parameter) {
// 	return pyAxios({
// 		url: '/sku/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }

//库存记录申领
export function claim_apply(parameter) {
	return axios({
		url: api.gateway_act+'claim_apply/save',
		method:'post',
		data:parameter
	})
}

// export function fake_sku_entry(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/add',
// 		method: 'post',
// 		data: parameter
// 	})
// }

// export function fake_sku_update(parameter) {
// 	return pyAxios({
// 		url: '/fake_sku/update',
// 		method: 'post',
// 		data: parameter
// 	})
// }
// export function fake_sku_checkin(parameter) {
// 	return pyAxios({
// 		url: '/fake_sku/checkin',
// 		method: 'post',
// 		data: parameter
// 	})
// }
// export function get_company_name(parameter) {
// 	return pyAxios({
// 		url: '/asset/get_company_name',
// 		method: 'get',
// 		params: parameter
// 	})
// }

// 耗材出入库
// export function transcation_get_list(parameter) {
// 	return pyAxios({
// 		url: '/asset/transcation/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }

//获取耗材列表
// export function sku_spu_get_list(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }

// export function get_cheap_list(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/get_cheap_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }

//查询部门所在公司
export function belong_company(parameter) {
	return axios({
		url: api.gateway_system+'dept/belong_company',
		method: 'get',
		params: parameter
	})
}

//流动资产录入
// export function spu_add(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/add',
// 		method: 'post',
// 		data: parameter
// 	})
// }

//流动资产编辑
// export function spu_update(parameter) {
// 	return pyAxios({
// 		url: '/sku/spu/update',
// 		method: 'post',
// 		data: parameter
// 	})
// }

// export function get_latest(parameter) {
// 	return pyAxios({
// 		url: '/sku/get_latest',
// 		method: 'get',
// 		params: parameter
// 	})
// }

export function get_biz_car_xlsx(parameter) {
	return downLoadPdf(
	'/act/biz_car_subsidy_apply/download',
	parameter
	)
}
export function get_biz_apply_car_xlsx(parameter) {
	return downLoadXlxs3(
		'/act/biz_car_apply/export',
		parameter
		)
}

export function get_list2_xlsx(parameter) {
	return downLoadXlxs(
	'/asset/get_list2',
	parameter
	)
}
//固定资产导出
// export function assetExcel(parameter) {
// 	return downLoadXlxs(
// 	'/daily/asset/excel',
// 	parameter
// 	)
// }

export function get_spu_xlsx(parameter) {
	return downLoadXlxs(
	'/sku/spu/get_list',
	parameter
	)
}

export function get_sku_xlsx(parameter) {
	return downLoadXlxs(
	'/sku/get_list',
	parameter
	)
}

export function get_transcation_xlsx(parameter) {
	return downLoadXlxs(
	'/asset/transcation/get_list',
	parameter
	)
}

//获取库存记录详情(固定资产)
// export function asset_transcation_get(parameter) {
// 	return pyAxios({
// 		url: '/asset/transcation/get',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// 检查库存
export function act_sku_num(parameter) {
	return axios({
		url: api.gateway_act+'claim_apply/sku',
		method: 'POST',
		data: parameter
	})
}

// 新增领用申请
export function biz_claim_save(parameter) {
	return axios({
		url: api.gateway_act+'biz_claim/save',
		method: 'POST',
		data: parameter
	})
}

// 查询领用申请列表
export function biz_claim_list(parameter) {
	return axios({
		url: api.gateway_act+'biz_claim/list',
		method: 'GET',
		params: parameter
	})
}

// 修改领用申请
export function biz_claim_update(parameter) {
	return axios({
		url: api.gateway_act+'biz_claim/update',
		method: 'POST',
		data: parameter
	})
}

// 查询我的领用记录列表
export function biz_claim_listByUser(parameter) {
	return axios({
		url: api.gateway_act+'biz_claim/listByUser',
		method: 'GET',
		params: parameter
	})
}

// 修改领用申请（驳回）
export function biz_claim_updateReject(parameter) {
	return axios({
		url: api.gateway_act+'biz_claim/updateReject',
		method: 'POST',
		data: parameter
	})
}

//获取固定资产退货列表
export function goods_rejected_selectAssetList(data) {
	return axios({
		url: api.gateway_act + 'goods_rejected/selectAssetList',
		method: 'get',
		params: data
	})
}

//获取流动资产退货列表
export function goods_rejected_getSpuList(data) {
	return axios({
		url: api.gateway_act + 'goods_rejected/getSpuList',
		method: 'get',
		params: data
	})
}

//获取付款编号
export function goods_rejected_code(data) {
	return axios({
		url: api.gateway_act + 'goods_rejected/code',
		method: 'get',
		params: data
	})
}

// 点击提交退货申请
export function goods_rejected_save(parameter) {
	return axios({
		url: api.gateway_act+'goods_rejected/save',
		method: 'POST',
		data: parameter
	})
}
//固定资产录入
export function assetInfo(parameter) {
	return axios({
		url: '/daily/asset/info',
		method: 'post',
		data: parameter
	})
}
//出入库记录查询
export function assetTranscation(data) {
	return axios({
		url: '/daily/asset/transcation',
		method: 'get',
		params: data
	})
}
//出入库记录固定资产详情
export function assetDeatil(data) {
	return axios({
		url: '/daily/asset/asset_info',
		method: 'get',
		params: data
	})
}
//资产转移给其他人
export function transferOther(parameter) {
	return axios({
		url: '/daily/transfer/toOther',
		method: 'post',
		data: parameter
	})
}
//资产设为库存
export function transferStock(parameter) {
	return axios({
		url: '/daily/transfer/toStock',
		method: 'post',
		data: parameter
	})
}
// 资产移交查询记录
export function transferList(data) {
	return axios({
		url: '/daily/transfer/getList',
		method: 'get',
		params: data
	})
}
//流动资产列表
export function consumablesList(data) {
	return axios({
		url: '/daily/consumables/list',
		method: 'get',
		params: data
	})
}
//直接入库列表
export function listSku(data) {
	return axios({
		url: '/daily/consumables/list_sku',
		method: 'get',
		params: data
	})
}
//流动资产直接入库
export function consumablesSku(parameter) {
	return axios({
		url: '/daily/consumables/sku',
		method: 'post',
		data: parameter
	})
}
//流动资产编辑
export function editConsumables(parameter) {
	return axios({
		url: '/daily/consumables/info',
		method: 'put',
		data: parameter
	})
}
//流动资产录入
export function addConsumables(parameter) {
	return axios({
		url: '/daily/consumables/info',
		method: 'post',
		data: parameter
	})
}
//耗材直接出库
export function consumablesSkuOut(parameter) {
	return axios({
		url: '/act/biz_claim/sku_out',
		method: 'post',
		data: parameter
	})
}
// 通过资产id 查询详情
export function scrapped_apply_asset(parameter) {
	return axios({
		url: '/act/scrapped_apply/biz/asset',
		method: 'get',
		params: parameter
	})
}
// 根据goodId查询流程详情
export function purchase_apply_asset(parameter) {
	return axios({
		url: '/act/purchase_apply/biz/asset',
		method: 'get',
		params: parameter
	})
}
//固定资产入库记录详情
export function assetList(parameter) {
	return axios({
		url: '/daily/asset/list_info',
		method: 'get',
		params: parameter
	})
}
export function getPurchaseList(parameter) {
	return downLoadXlxs3(
	 '/act/purchase_list/export',
	 parameter
	 )
	}